import React from 'react';
type NewsletterEmbedProps = {
  className?: string;
};
export function NewsletterEmbed({
  className = ''
}: NewsletterEmbedProps) {
  return <iframe src="https://embeds.beehiiv.com/792bb15f-3a0a-4874-bffc-3a18450d8d36?slim=true" data-test-id="beehiiv-embed" title="Subscribe to Broken Pencils" height="52" frameBorder="0" scrolling="no" className={className} style={{
    margin: 0,
    borderRadius: '0px',
    backgroundColor: 'transparent',
    width: '100%'
  }} data-id="element-152" data-mp="2n7cm0v7gg5kf"></iframe>;
}